<script setup>

import BaseModal from '@/components/Alerts/BaseModal.vue'
import { Format } from '@/models/utils/FormatUtils.js'
import DefaultCard from '@/components/Forms/DefaultCard.vue'

const props = defineProps({
	show: { type: Boolean, default: false },//Show modal
	modalData: { type: Object, default: null },
})

const emit = defineEmits(['evCloseModal'])//Used by DataSubmissionsPage to close modal

/**
 * Gets the file name for the data submission in the enclave or local
 * @returns {string}
 */
function getFileName()
{
	const file = props.modalData.s3_object_key;

	if (!file || file === '') return props.modalData.file_name; //return file name for local development

	return file.slice(file.lastIndexOf("/") + 1)
}

function closeModal()
{
	emit('evCloseModal', 'history')
}
</script>

<template>
	<div>
		<BaseModal :show="show" border-classes="border-t-6 border-tertiary">
			<div class="flex flex-col w-136 h-192 max-h-192">
				<div class="flex justify-between border-b border-neutral w-full pb-6">
					<p class="flex-grow text-xl font-bold text-heading">History</p>
					<img src="@/assets/images/icon/dismiss.svg" alt="Dismiss" title="Dismiss" class="cursor-pointer size-4" @click.prevent="closeModal">
				</div>

				<div class="flex flex-col py-4">
					<span class="text-heading font-bold">Data Submission Source</span>
					<span class="text-heading">{{ getFileName() }}</span>
					<span class="text-grayscale-body">Created {{ Format.date(modalData.created_at) }}</span>
				</div>

				<div class="flex flex-col gap-y-4 overflow-y-auto flex-1">
					<DefaultCard v-for="history in modalData.history" :key="history.id" inner-padding="p-4">
						<div class="flex flex-col">
							<span class="text-label font-medium">{{ history.user_name }}</span>
							<span class="text-grayscale-body">{{ Format.date(history.created_at) }}</span>
							<div v-if="history.action" class="flex flex-col">
								<span class="mt-2 text-grayscale-body">Action: <span class="text-label font-medium">{{ history.action }}</span></span>
							</div>
							<span v-if="history.comment" class="mt-2 text-grayscale-body">Notes:</span>
							<span v-if="history.comment" class="bg-primary-subtler border border-primary-bold-hover rounded p-3 text-label mt-1" v-html="history.comment"/>
						</div>
					</DefaultCard>
				</div>
			</div>
		</BaseModal>
	</div>
</template>

<style scoped>

</style>